export const MFA_METHOD_EMAIL = 0
export const MFA_METHOD_SMS = 1
export const MFA_METHOD_APP = 2

export const UPLOAD_DOC = 0
export const UPLOAD_IMG = 1